import * as React from 'react'
import * as ReactRouter from 'react-router-dom'
import PropTypes from 'prop-types'
import { typography } from 'styled-system'

import * as common from '@rushplay/common'
import css from '@styled-system/css'
import styled from '@emotion/styled'
import { useI18n } from '@rushplay/i18n'

import { Heading } from './heading'

export const NavigationLink = styled(ReactRouter.NavLink)`
  white-space: nowrap;
  text-decoration: none;
  padding-top: 2px;
  border-bottom: 2px solid;
  border-color: transparent;
  color: rgba(255, 255, 255, 0.5);
  scroll-snap-align: start;
  ${css({
    fontFamily: 'head',
    fontWeight: 'bold',
    fontStyle: 'normal',
    '&.active, &:hover': {
      color: 'white',
      borderColor: 'currentColor',
    },
  })};
  ${typography};
`

NavigationLink.defaultProps = {
  fontSize: 2,
}

const ScrollableRow = styled.div`
  overflow-y: hidden;
  overflow-x: scroll;
  padding-bottom: 10px;
  display: flex;
  column-gap: 32px;
  scroll-snap-type: inline mandatory;

  ${css({
    px: [1, 2],
    scrollPaddingInline: ['16px', '24px'],
  })};

  -webkit-overflow-scrolling: touch;

  @media (hover: hover) {
    ::-webkit-scrollbar {
      height: 10px;
      background-color: transparent;
    }

    ::-webkit-scrollbar-thumb {
      background-color: transparent;
      border-radius: 10px;
    }

    ::-webkit-scrollbar-track {
      background-color: transparent;
    }

    &:hover {
      ::-webkit-scrollbar-thumb {
        background-color: rgb(255, 255, 255, 0.3);
      }
    }
  }
`

export function PageNavigation(props) {
  const i18n = useI18n()

  return (
    <React.Fragment>
      {props.header && (
        <common.Space pb="2" px={[1, 2]}>
          <Heading level={2} color="page-nav-heading">
            {i18n.translate(props.header)}
          </Heading>
        </common.Space>
      )}
      <ScrollableRow>{props.items}</ScrollableRow>
    </React.Fragment>
  )
}

PageNavigation.defaultProps = {
  items: [],
}

PageNavigation.propTypes = {
  header: PropTypes.string,
  items: PropTypes.node.isRequired,
}
